/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Core owns the navigation toggle appearance; consumers own panel state and placement.
 */
import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { ComponentIcon } from './ComponentIcon';
import './SidebarToggleButton.css';

export interface SidebarToggleButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'onClick' | 'aria-expanded' | 'aria-controls' | 'aria-label' | 'title'
> {
  expanded: boolean;
  onToggle: () => void;
  label: string;
  controlsId: string;
  /** Physical panel edge, independent of the content's text direction. */
  side: 'left' | 'right';
}

export const SidebarToggleButton = forwardRef<HTMLButtonElement, SidebarToggleButtonProps>(
  function SidebarToggleButton({
    expanded,
    onToggle,
    label,
    controlsId,
    side,
    className = '',
    type = 'button',
    ...buttonProps
  }, ref) {
    const pointsLeft = side === 'left' ? expanded : !expanded;

    return (
      <button
        {...buttonProps}
        ref={ref}
        type={type}
        className={`btn-icon qp-sidebar-toggle-button${className ? ` ${className}` : ''}`}
        data-panel-side={side}
        aria-expanded={expanded}
        aria-controls={controlsId}
        aria-label={label}
        title={label}
        onClick={onToggle}
      >
        <ComponentIcon name={pointsLeft ? 'chevronLeft' : 'chevronRight'} size={20} />
      </button>
    );
  },
);
